import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData } from "../../../lib/collegerank";

export default function InstructorDesiredColleges() {
  const [colleges, setColleges] = useState([]);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetData();
      console.log("Delete", id);
      //router.refresh();
    }
  };

  async function GetData() {
    const collegs = await getAllData();
    setColleges(collegs);
    console.log("collegs", collegs);
  }

  useEffect(() => {
    GetData();
  }, []);

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex pb-1 justify-content-between align-items-center">
            <div>
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }
    
  return (
    <div className="col-xl-12 col-md-12 mx-auto">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-2">
          {essentialheader(
            "College List",
            "Add New College",
            "/instructor/instructor-desiredcolleges-edit/Add"
            )}
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>

                    <th>Parameter</th>
                    <th></th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {colleges.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link to="#" className="invoice-no">
                            {data.id}
                          </Link>
                        </td>

                        <td>{data.collegename}</td>
                        <td></td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            <Link
                              to={`/instructor/instructor-desiredcolleges-edit/${data.id}`}
                              className="btn btn-success btn-sm"
                            >
                              Update
                            </Link>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => handleDelete(data.id)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
